import React from "react";

const FBannerTitle = ({ imageUrl, title }) => {
  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-12 xss:w-[450px] text-[5vw] smm:text-[25px] place-items-center">
          <div className="border-0 col-span-5">
            <img
              src={imageUrl}
              className="w-full xxs:w-[150px] h-auto flex-1"
            />
          </div>
          <div className="border-0 col-span-7 grid grid-rows-1 text-center py-3 sm:py-7">
            <div className="border-0 row-span-1 font-bold text-Secondary">
              {title}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FBannerTitle;
